var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.5C12.5 15.5 10.5 15.9095 9.29553 14.7051C7.09788 12.5074 7.09838 8.93128 9.29553 6.73385L11.378 4.65037C12.4425 3.58575 13.8585 3 15.364 3C16.8693 3 18.2847 3.58645 19.3484 4.65037C20.4129 5.71499 21 7.13114 21 8.63678C21 10.1424 20.4136 11.5579 19.3484 12.6217M4.65016 11.3782C3.58638 12.4421 3 13.8576 3 15.3632C3 16.8689 3.58708 18.285 4.65157 19.3482C5.71532 20.4135 7.13072 21 8.63604 21C10.1415 21 11.5551 20.4143 12.6196 19.3496L14.5306 17.4384C15.5958 16.3751 16.1822 14.959 16.1822 13.4535C16.1822 11.9464 15.364 9.5 13 8.63678",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink2);
export default __webpack_public_path__ + "static/media/link2.ede9f113ae3f8c9f4ae0c9a68991739f.svg";
export { ForwardRef as ReactComponent };